// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues, parseDate, parseDateTime, serializeDate, serializeDateTime } from "../runtime";
/**
 *
 * @export
 * @interface BoundedTimeAxis
 */
export interface BoundedTimeAxis {
  /**
   *
   */
  origin: Date;
  /**
   *
   */
  delta: string;
  /**
   *
   */
  size: number;
}

/**
 * Check if a given object implements the BoundedTimeAxis interface.
 */
export function instanceOfBoundedTimeAxis(value: object): value is BoundedTimeAxis {
  if (!("origin" in value) || value["origin"] === undefined) return false;
  if (!("delta" in value) || value["delta"] === undefined) return false;
  if (!("size" in value) || value["size"] === undefined) return false;
  return true;
}

export function BoundedTimeAxisFromJSON(json: any): BoundedTimeAxis {
  return BoundedTimeAxisFromJSONTyped(json, false);
}

export function BoundedTimeAxisFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): BoundedTimeAxis {
  if (json == null) {
    return json;
  }
  return {
    origin: json["origin"] == null ? json["origin"] : parseDateTime(json["origin"]),
    delta: json["delta"],
    size: json["size"],
  };
}

export function BoundedTimeAxisToJSON(json: any): BoundedTimeAxis {
  return BoundedTimeAxisToJSONTyped(json, false);
}

export function BoundedTimeAxisToJSONTyped(
  value?: BoundedTimeAxis | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    origin: value["origin"] == null ? value["origin"] : serializeDateTime(value["origin"]),
    delta: value["delta"],
    size: value["size"],
  };
}
